<style>
    .pre-scrollable {
        max-height: 660px
    }
</style>
<template>
    <div>
        <!--<span class="pull-right" style="margin:5px">
            <a class="btn btn-default btn-xs" @click.prevent.self="SelectAll">Select All</a>
            <a class="btn btn-default btn-xs" @click.prevent.self="DeselectAll">Deselect All</a>
        </span>
        <br />-->
        <a class="btn btn-default btn-xs" @click.prevent.self="SelectAll"    style="margin-bottom:5px">Select All</a>
        <a class="btn btn-default btn-xs" @click.prevent.self="DeselectAll"  style="margin-bottom:5px">Deselect All</a>
        <div class="list-group pre-scrollable">
            <a href="#" v-for="(item,index) in selection" class="list-group-item list-group-item-action" v-on:click.prevent="OnSelect(index)">
                <div class="row">
                    <div class="col-sm-10" v-bind:class="{'text-primary': item.IsSelected}">
                        <span style="font-weight:500; font-size:14px">{{item.Object.firstName}} {{item.Object.lastName}}</span>
                        <span class="pull-right">{{FormatDate(item.Object.dob)}}</span>
                    </div>
                    <div class="col-sm-2">
                        <span class="text-primary pull-right" v-if="item.IsSelected">
                            <i class="fa fa-check fa-1x"></i>
                        </span>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import SelectableObject from "../../helpers/SelectableObject";

    export default {
        props: ['carehomeId', 'wardId', 'patientId', 'value'],
        data: function () {
            return {
                selection: [],
                selectedCount: 0
            }
        },
        mounted: function () {
            this.Load();
        },
        watch: {
            carehomeId: function () { this.Load() },
            wardId: function () { this.Load() },
            patientId: function () {
                console.log("PPatienId changed")
                this.Load()
            },
        },
        methods: {
            SelectAll() {
                for (var selection of this.selection) {
                    selection.IsSelected = true;
                }
                this.UpdateSelection();
            },
            DeselectAll() {
                for (var selection of this.selection) {
                    selection.IsSelected = false;
                }
                this.UpdateSelection();

            },
            Load: function () {
                var dal = new Dal();

                if (this.carehomeId != null && this.wardId != null) {
                    console.log("Loading ", this.carehomeId, this.wardId, this.patientId)
                    var selectAllPatients = this.patientId == null;

                    dal.GetPatients(this.carehomeId).then(items => {
                        this.selection = [];
                        for (var item of items) {
                            if (item.wardId == this.wardId) {
                                var selectPatient = true;
                                if (this.patientId != null) {
                                    selectPatient = item.id == this.patientId;
                                }
                                this.selection.push(new SelectableObject(item, selectPatient));
                            }
                        }
                        this.UpdateSelection();
                    })
                }
            },
            FormatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            OnSelect: function (index) {
                this.selection[index].IsSelected = !this.selection[index].IsSelected;
                this.UpdateSelection();
            },
            UpdateSelection: function () {
                this.selectedCount = 0;
                var currentSelection = [];
                for (var item of this.selection) {
                    if (item.IsSelected) {
                        this.selectedCount += 1;
                        currentSelection.push(item.Object)
                    }
                }
                this.$props.value = currentSelection;
                this.$emit('input', currentSelection);
            }
        },
        components: {
            Formatter
        }
    }
</script>


// WEBPACK FOOTER //
// PatientSelector.scp.html?397251ab